module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Book-Of-Love-The.8f6f20a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Book-Of-Love-The.jpg
// module id = sJeS
// module chunks = 0